lmApp.service('AdsService', [
  function () {
    var service = {};

    service.ValidateAd = function (ad) {
      ad._error = {};
      if (!ad.name) {
        ad._error.name = 'Required';
      }
      if (ad.pictures.filter(function (value) { return !value.source; }).length) {
        ad._error.pictures = 'Empty image';
      }
      if (ad._link_info.type === 'asset' && !ad._link_info.asset.id) {
          ad._error.assetLink = 'Required';
      }
      if (ad._link_info.type === 'external' && !ad._link_info.link) {
        ad._error.externalLink = 'Required';
      }
      return _.isEmpty(ad._error);
    };

    return service;
  }
]);
